import { call, put } from 'redux-saga/effects';

import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { DatasourceContentType, FlowContentType, PublishedConnectionContentType, WorkbookContentType } from '~src/spacesPlatform/models/ContentTypes';
import { reloadSpaceIfUpdatingCurrentSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';
import { getCorrectEntityIdForActions } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import {
  requestFailed
} from '../../app/actions/RequestFailedAction';
import { RevisionHistoryAction } from '../../app/actions/spaces/RevisionHistoryAction';
import { Messages } from '../../codegen/Localize';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import {
  RevisionHistoryActionInstance
} from '../services/RevisionHistoryAction';

export function* handleRevisionHistoryAction(action: RevisionHistoryAction) {
  try {
    const entityId = yield call(getCorrectEntityIdForActions, action.content.contentType, action.content.id);
    yield call(openRevisionHistoryDialog, { ...action.content, id: entityId });

    const didReload = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.content]);
    if (!didReload) {
      yield put(requestSpaceContents());
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openRevisionHistoryDialog(content: IContentInfo): Promise<IResult> {
  const revisionHistoryService = RevisionHistoryActionInstance;
  switch (content.contentType) {
    case WorkbookContentType.name:
      return revisionHistoryService.showWorkbookRevisionHistory(content);
    case DatasourceContentType.name:
      return revisionHistoryService.showDataSourceRevisionHistory(content);
    case FlowContentType.name:
      return revisionHistoryService.showFlowRevisionHistory(content);
    case PublishedConnectionContentType.name:
      return revisionHistoryService.showPublishedConnectionRevisionHistory(content);
  }
}
